app.service('stickyHeader', function (front, html) {
	var timeout;

	function init() {
		if (front.getParam('stickyHeader')) {
			html.add('sticky-header');
			const el = document.querySelector('#header') || document.querySelector('#header-native-app');
			const observer = new IntersectionObserver(
				([e]) => e.intersectionRatio < 1 ? pinned() : notPinned(),
				{ threshold: [1] }
			);
			observer.observe(el);
		}
	}
	function pinned() {
		console.log('header pinned')
		if(!timeout){
			timeout = setTimeout(() => {
				html.add('sticky-header-pinned');
				timeout = null;
			}, 100)
		}
	}
	function notPinned() {
		console.log('header not pinned')
		if(!timeout){
			timeout = setTimeout(() => {
				html.remove('sticky-header-pinned');
				timeout = null;
			}, 100)
		}
	}

	return {
		init
	};
});
